import { useEffect, useRef, useState } from 'react';
import { statsData } from '@/mocks/home';

export default function StatsSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  const [counts, setCounts] = useState(statsData.map(() => 0));

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    const targets = [5000, 200, 10, 50];
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      const progress = currentStep / steps;
      const eased = 1 - Math.pow(1 - progress, 3);
      setCounts(targets.map((t) => Math.round(t * eased)));
      if (currentStep >= steps) {
        clearInterval(timer);
        setCounts(targets);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {statsData.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-background-50/15 flex items-center justify-center">
                <i className={`${stat.icon} text-background-50 text-2xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl font-bold text-background-50 font-heading mb-1.5">
                {idx < 2 ? `${counts[idx]}万+` : idx === 2 ? `${counts[idx]}亿+` : `${counts[idx]}+`}
              </div>
              <div className="text-background-50/70 text-xs md:text-sm font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}